import { Grid, Typography } from "@mui/material"

const Footer = () => {
    return (
        <Grid container
            sx={{
                minHeight: 56,
                marginTop: 5,
                marginBottom: 3,
                px: 2
            }}
            alignItems='center'
        >
            <Grid item xs={12}
                sx={{
                    textAlign: 'center'
                }}
            >
            <Typography 
                variant='caption' 
                sx={{
                    fontFamily: 'Roboto Mono',
                }}>
            © {new Date().getFullYear()} hengyilin.xyz, All Rights Reserved.
            </Typography>
            <Typography
                variant='caption'
                sx={{
                    display: 'block',
                    mt: 0.6,
                    maxWidth: 760,
                    mx: 'auto',
                    color: '#6B6B6B',
                    fontFamily: 'Roboto Mono',
                }}
            >
            EngBlogs is an independent aggregator of publicly available RSS and blog content. It is not affiliated with, sponsored by, or endorsed by the companies featured here; all trademarks and original content belong to their respective owners.
            </Typography>
            </Grid>
        </Grid>
    )
}

export default Footer
